module.exports = __webpack_public_path__ + "static/media/RicHickeyoutsidecover.82cb8d97.webp";